export const isApiReachable = async (apiUrl: string, timeoutMs: number): Promise<boolean> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), timeoutMs)

  try {
    // no-cors still resolves for any answer, a 404 included, and only rejects when the request itself fails
    await fetch(apiUrl, { method: 'HEAD', mode: 'no-cors', cache: 'no-store', signal: controller.signal })

    return true
  } catch {
    return false
  } finally {
    clearTimeout(timeout)
  }
}
